import React from 'react'
import { useTranslation, TFunction } from 'react-i18next'
import IconRoadMapEN from '~/assets/images/road-map-mobile-EN.svg'
import IconRoadMapZH from '~/assets/images/road-map-mobile-ZH.svg'
import { LOCALES } from '~/locales'
import { StyledRoadMapWrapper, StyledRoadMapGraph } from './styled'
import { NodeProps, RoadMapNode } from './types'

const MAKE_ROAD_MAP_NODES: (t: TFunction) => RoadMapNode[] = (t) => [
  {
    stageStamp: '2020',
    progress: '0',
    isPrimary: true,
    isSingle: true,
  },
  {
    stageStamp: 'Q4',
    height: 133,
    progress: '17%',
    phase: 0,
    stage: t('genesis_mining'),
  },
  {
    stageStamp: '2021',
    progress: '3%',
    height: 62,
    phase: 1,
    stage: t('economic_build_model'),
    isPrimary: true,
  },
  {
    stageStamp: 'Q3',
    progress: '14%',
    height: 134,
    phase: 2,
    stage: t('launch_governance'),
  },
  {
    stageStamp: '2022',
    progress: '6.6%',
    isPrimary: true,
    height: 61,
    phase: 3,
    stage: t('public_network'),
  },
  {
    stageStamp: '2023',
    progress: '22%',
    height: 69,
    isPrimary: true,
    phase: 4,
    stage: t('cross_chain_channel'),
  },
]

const Node: React.FC<NodeProps> = ({
  stage,
  phase,
  isPrimary,
  isSingle,
  height,
  stageStamp,
}) => {
  const headSize = isPrimary ? '48px' : '18px'

  return (
    <div className="road-map-node-wrapper">
      <div
        className={
          isPrimary ? 'road-map-node-circle-primary' : 'road-map-node-circle'
        }
      >
        <div className="road-map-node-stage-stamp">{stageStamp}</div>
      </div>
      {!isSingle && (
        <div className="road-map-node-attach">
          <div
            className={
              isPrimary
                ? 'road-map-node-line-wrapper-primary'
                : 'road-map-node-line-wrapper'
            }
            style={{ width: headSize }}
          >
            <div className="road-map-node-line" style={{ height }}></div>
          </div>
          <div className="road-map-node-info-wrapper">
            <div className="road-map-node-phase">Phase-{phase}</div>
            <div className="road-map-node-stage">{stage}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export const RoadMap: React.FC = () => {
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const renderNodes = MAKE_ROAD_MAP_NODES(t).map(
    ({ progress, ...nodeProps }, index) => (
      <div
        className="road-map-node-container"
        style={{ marginLeft: progress }}
        key={index}
      >
        <Node {...nodeProps} />
      </div>
    ),
  )

  return (
    <StyledRoadMapWrapper>
      <div className="road-map-title">{t('road_map')}</div>
      <div className="road-map-graph-mobile">
        <img
          className="road-map-graph-img-mobile"
          src={isZh ? IconRoadMapZH : IconRoadMapEN}
        />
      </div>
      <StyledRoadMapGraph>
        <div className="road-map-base-line"></div>
        <div className="road-map-nodes">{renderNodes}</div>
      </StyledRoadMapGraph>
    </StyledRoadMapWrapper>
  )
}
